/**
 * Created by hashinig on 6/30/18.
 */
(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name adminCrewBatchers.factory:CrewBatchFactory
   *
   * @description
   *
   */
  angular
    .module('trainingRoster')
    .factory('TrainingRosterFactory', TrainingRosterFactory);

  function TrainingRosterFactory() {


    function SearchCriteriaDTO() {
      this.rosterCycleId = null;
    }

    function TrainingDTO(){
      this.expiryStart = null;
      this.expiryEnd = null;
      this.cycle = null;
      this.processingStatus = null;
      this.status = null;
      this.trainingAutomationConfigId = null;
      this.trainingProgramCategoryCode = null;
      this.trainingProgramCode = null;
      this.trainingProgramId = null;
      this.version = null;
      this.crewTypes = null;
      this.isSelected = false;
    }

    function EditTrainingDTO(){
      this.expiryStart = null;
      this.expiryEnd = null;
      this.cycle = null;
      this.trainingProgramObject = null;
      this.programDetailsObject = null;
      this.crewTypeCodesList = null;
      this.trainingAutomationConfigId = null;
      this.processingStatus = null;
      this.scheduleStatus = null;
      this.processingStatus = null;
      this.version = null;
    }
    function TrainingAutomationSaveRequest(){
      this.trainingAutomationConfigId=null;
      this.rosterCycleId = null;
      this.trainingProgramId=[];
      this.expiryStartDateTime = null;
      this.expiryEndDateTime = null;
      this.scheduleStatus = null;
      this.version = null;
      this.crewTypes = []
    }


    function AssignTrainings(){
      this.trainingAutomationConfigIds = [];
    }


    function PopulateTrainingSearchRequest(params){
      var searchRequest = new SearchCriteriaDTO();
      // searchRequest.pageSize = passCriteria.pageSize;
      // searchRequest.startPosition = passCriteria.startPosition;
      if(!!params.cycle){
        searchRequest.rosterCycleId = params.cycle.cycleId;
      }
      return searchRequest;
    }

    function FormatTrainingInfoSearchResponse(dataList) {
      var trainingInfo = [];
      angular.forEach(dataList, function(tr) {
        var training = new TrainingDTO();
        training.expiryStart = tr.expiryStartDateTime;
        training.expiryEnd = tr.expiryEndDateTime;
        training.cycle = tr.rosterCycleId;
        training.processingStatus = tr.processingStatus;
        training.status = tr.scheduleStatus;
        training.trainingAutomationConfigId = tr.trainingAutomationConfigId;
        training.trainingProgramCategoryCode = tr.trainingProgramCategoryCode;
        training.trainingProgramCode = tr.trainingProgramCode;
        training.trainingProgramId = tr.trainingProgramId;
        training.version = tr.version;
        training.crewTypes = tr.crewTypes;

        trainingInfo.push(training);
      });
      return trainingInfo;
    }


    function GetNewTraining(){
      var trainingInfo = new EditTrainingDTO();

      return trainingInfo;
    }

    function GetTrainingAutomationSaveRequest(){
      var trainingInfo = new TrainingAutomationSaveRequest();

      return trainingInfo;
    }

    function FormatGridSelectedRow(selectedItem,masterList){
      var training = new EditTrainingDTO();
      training.expiryStart = selectedItem.expiryStart;
      training.expiryEnd = selectedItem.expiryEnd;
      training.cycle =  _.find(masterList.cycleList, {'cycleId' : selectedItem.cycle});
      var categories =[];
      angular.forEach( selectedItem.trainingProgramCategoryCode.split(','), function(category){
        if(!categories.includes(category + " ")){
          categories.push(category + " ");
        }
      });
      training.trainingProgramObject = masterList.trainingCategories.filter(function(cat){return categories.includes(cat.categoryCode)});
      training.programDetailsObject = null;
      training.crewTypeCodesList = _.filter(masterList.crewTypes ,function(crew){return _.contains(selectedItem.crewTypes,crew.crewTypeCode)});
      training.trainingAutomationConfigId = selectedItem.trainingAutomationConfigId;
      training.scheduleStatus = selectedItem.status;
      training.processingStatus = selectedItem.processingStatus;
      training.version = selectedItem.version;
      //training.programDetailsObject = _.filter(masterList.allProgramDetails ,function(prog){return _.contains(selectedItem.trainingProgramId,prog.trainingProgramId)});
      return training;

    }


    function PopulateTrainingAssignmentRequest(cycleIdList){
      var assignTrainings = new AssignTrainings()
      assignTrainings.trainingAutomationConfigIds = cycleIdList;

        return assignTrainings;

    }


    return {
      formatGridSelectedRow : FormatGridSelectedRow,

      getNewTraining : GetNewTraining,
      populateTrainingSearchRequest : PopulateTrainingSearchRequest,
      formatTrainingInfoSearchResponse : FormatTrainingInfoSearchResponse,
      populateTrainingAssignmentRequest : PopulateTrainingAssignmentRequest,
      getTrainingAutomationSaveRequest : GetTrainingAutomationSaveRequest
    }
  }
})();
